module.exports = __webpack_public_path__ + "img/attachment_light.74223501.svg";